"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var colors_1 = require("../colors");
var Garbage = function (_a) {
    var type = _a.type, width = _a.width, height = _a.height, fill = _a.fill;
    switch (type) {
        case 'line':
        default:
            return (React.createElement("svg", { width: width, height: height, viewBox: "0 0 40 40", fill: "none" },
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.9091 11.8182H9.09088V37.2727H27.2727C29.2809 37.2727 30.9091 35.6445 30.9091 33.6364V11.8182ZM25.9091 21.3636L24.0909 23.1818L21.3636 20.4545V27.8156C20.2681 27.8156 18.4521 26.9278 18.4521 25.8323V20.6392L15.9091 23.1818L14.0909 21.3636L20 15.4545L25.9091 21.3636Z", fill: fill }),
                React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.8182 6.36366C21.8182 4.35549 20.19 2.72729 18.1818 2.72729V6.36366H7.27271V10H32.7272V6.36366H21.8182Z", fill: fill })));
    }
};
Garbage.propTypes = {
    type: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fill: PropTypes.string,
};
Garbage.defaultProps = {
    type: 'solid',
    width: 40,
    height: 40,
    fill: colors_1.grey5,
};
exports.default = Garbage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2FyYmFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pY29ucy9HYXJiYWdlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLDZCQUErQjtBQUMvQixzQ0FBd0M7QUFFeEMsb0NBQWdDO0FBUWhDLElBQU0sT0FBTyxHQUEyQixVQUFDLEVBQTJCO1FBQTFCLGNBQUksRUFBRSxnQkFBSyxFQUFFLGtCQUFNLEVBQUUsY0FBSTtJQUNqRSxRQUFRLElBQUksRUFBRTtRQUNaLEtBQUssTUFBTSxDQUFDO1FBQ1o7WUFDRSxPQUFPLENBQ0wsNkJBQUssS0FBSyxFQUFFLEtBQUssRUFBRSxNQUFNLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBQyxXQUFXLEVBQUMsSUFBSSxFQUFDLE1BQU07Z0JBQ2hFLDhCQUNFLFFBQVEsRUFBQyxTQUFTLEVBQ2xCLFFBQVEsRUFBQyxTQUFTLEVBQ2xCLENBQUMsRUFBQywrUUFBK1EsRUFDalIsSUFBSSxFQUFFLElBQUksR0FDVjtnQkFDRiw4QkFDRSxRQUFRLEVBQUMsU0FBUyxFQUNsQixRQUFRLEVBQUMsU0FBUyxFQUNsQixDQUFDLEVBQUMsNEdBQTRHLEVBQzlHLElBQUksRUFBRSxJQUFJLEdBQ1YsQ0FDRSxDQUNQLENBQUM7S0FDTDtBQUNILENBQUMsQ0FBQztBQUVGLE9BQU8sQ0FBQyxTQUFTLEdBQUc7SUFDbEIsSUFBSSxFQUFFLFNBQVMsQ0FBQyxNQUFhO0lBQzdCLEtBQUssRUFBRSxTQUFTLENBQUMsU0FBUyxDQUFDLENBQUMsU0FBUyxDQUFDLE1BQU0sRUFBRSxTQUFTLENBQUMsTUFBTSxDQUFDLENBQVE7SUFDdkUsTUFBTSxFQUFFLFNBQVMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxTQUFTLENBQUMsTUFBTSxFQUFFLFNBQVMsQ0FBQyxNQUFNLENBQUMsQ0FBUTtJQUN4RSxJQUFJLEVBQUUsU0FBUyxDQUFDLE1BQU07Q0FDdkIsQ0FBQztBQUVGLE9BQU8sQ0FBQyxZQUFZLEdBQUc7SUFDckIsSUFBSSxFQUFFLE9BQU87SUFDYixLQUFLLEVBQUUsRUFBRTtJQUNULE1BQU0sRUFBRSxFQUFFO0lBQ1YsSUFBSSxFQUFFLGNBQUs7Q0FDWixDQUFDO0FBRUYsa0JBQWUsT0FBTyxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/@riiid/santa-closet-web/icons/Garbage.js
// module id = 68
// module chunks = 0